import  ProductFullContent from './ProductFullContent';
export default ProductFullContent
